/**
 * @generated SignedSource<<6b167150cc58177efe723ed182f69949>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ThemeEvaluated$data = {
  readonly projectId: string | null | undefined;
  readonly projectType: JiraProjectType | null | undefined;
  readonly " $fragmentType": "ThemeEvaluated";
};
export type ThemeEvaluated$key = {
  readonly " $data"?: ThemeEvaluated$data;
  readonly " $fragmentSpreads": FragmentRefs<"ThemeEvaluated">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ThemeEvaluated",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "projectType"
    },
    {
      "kind": "ScalarField",
      "name": "projectId"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "9bc6a556dad6e9a6508f296e65c79d05";

export default node;
